import DealAutomationRulesAPI from 'dashboard/api/pipelines/dealAutomationRules';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isCloning: false,
  },
};

export const getters = {
  getRules(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }, { accountId }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await DealAutomationRulesAPI.get(accountId);
      commit('SET_ITEMS', response.data?.data || []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async ({ commit }, { accountId, rule }) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await DealAutomationRulesAPI.create(accountId, rule);
      commit('ADD_ITEM', response.data?.data || response.data);
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit }, { accountId, id, rule }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await DealAutomationRulesAPI.update(accountId, id, rule);
      commit('UPDATE_ITEM', response.data?.data || response.data);
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  delete: async ({ commit }, { accountId, id }) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await DealAutomationRulesAPI.delete(accountId, id);
      commit('DELETE_ITEM', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  clone: async ({ commit }, { accountId, id }) => {
    commit('SET_UI_FLAG', { isCloning: true });
    try {
      const response = await DealAutomationRulesAPI.clone(accountId, id);
      commit('ADD_ITEM', response.data?.data || response.data);
    } finally {
      commit('SET_UI_FLAG', { isCloning: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  SET_ITEMS(_state, items) {
    _state.records = Array.isArray(items) ? items : [];
  },

  ADD_ITEM(_state, item) {
    if (!item?.id) return;
    const exists = _state.records.some(record => record.id === item.id);
    if (!exists) _state.records.unshift(item);
  },

  UPDATE_ITEM(_state, item) {
    const index = _state.records.findIndex(record => record.id === item.id);
    if (index === -1) return;
    _state.records[index] = { ..._state.records[index], ...item };
  },

  DELETE_ITEM(_state, id) {
    _state.records = _state.records.filter(record => record.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
